import { Alert, Box, Card, CardContent, Stack } from "@mui/material";
import { addDays, subDays } from "date-fns";
import { useMemo } from "react";
import { Button } from "react-admin";
import BidsVisualizationSkeleton from "./BidsVisualizationSkeleton";
import { BidsChart } from "./components/BidsChart";
import { DateSelector } from "./components/DateSelector";
import { CHART_HEIGHT } from "./constants";
import { useBidsChartData } from "./hooks/useBidsChartData";
import { useBidsChartOptions } from "./hooks/useBidsChartOptions";
import useRegelBidsData from "./hooks/useRegelBidsData";

const BidsVisualization = () => {
  const { bids, loading, error, selectedDate, requiredProducts, customFormatDate, handleDateChange } =
    useRegelBidsData();

  const chartData = useBidsChartData({
    bids,
    selectedDate,
    requiredProducts,
    customFormatDate,
  });

  const chartOptions = useBidsChartOptions({
    chartData,
    bids,
  });

  const isEmptyData = useMemo(() => {
    return chartData.series
      .map(({ data }) => data)
      .flat()
      .every((value) => value === 0);
  }, [chartData.series]);

  return (
    <Card>
      <CardContent>
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <Stack direction="row" spacing={2} alignItems="center" mb={2} width={"400px"} justifyContent={"center"}>
            <Button
              label="<"
              variant="contained"
              size="large"
              onClick={() => handleDateChange(subDays(selectedDate, 1))}
              disabled={loading}
            />
            <DateSelector
              selectedDate={selectedDate}
              onDateChange={handleDateChange}
              label="Select Date"
              disabled={loading}
            />
            <Button
              label=">"
              variant="contained"
              size="large"
              onClick={() => handleDateChange(addDays(selectedDate, 1))}
              disabled={loading}
            />
          </Stack>
        </Box>
        {error && <Alert severity="error">Error: {error.message}</Alert>}
        {loading ? (
          <BidsVisualizationSkeleton height={CHART_HEIGHT} />
        ) : isEmptyData ? (
          <Alert severity="info">No data available for the selected date</Alert>
        ) : (
          <BidsChart options={chartOptions} series={chartData.series} />
        )}
      </CardContent>
    </Card>
  );
};

export default BidsVisualization;
